import { RainfallBand } from "./types";

/** Full-quality overlay width. Kept moderate so GroundOverlay zoom stays fluid. */
export const DEFAULT_SURFACE_WIDTH = 520;
export const DEFAULT_SURFACE_HEIGHT = 520;

/** Fast first paint while the full surface is still computing. */
export const PREVIEW_SURFACE_WIDTH = 280;

export const DEFAULT_IDW_POWER = 1.5;

export const DEFAULT_RBF_SMOOTHING = 0.8;

export const DEFAULT_BLOCK_GAP_KM = 0.35;

export const DEFAULT_SURFACE_OPACITY = 0.82;

export const DEFAULT_EDGE_FEATHER_RATIO = 0;

export const DEFAULT_SURFACE_BLUR_PX = 0;

export const DEFAULT_VALUE_BLUR_RADIUS = 4;

export const STATION_BUFFER_KM = 4;

export const VALUE_WITHOUT_STATION_MM = 0;

export const KM_PER_DEGREE = 111.32;

export function stationBufferDegrees(
  bufferKm: number = STATION_BUFFER_KM,
): number {
  return bufferKm / KM_PER_DEGREE;
}

export const REFERENCE_RAINFALL_BANDS: RainfallBand[] = [
  {
    codigo: 0,
    minMm: Number.NEGATIVE_INFINITY,
    maxMm: 0,
    color: "#C8E6C9",
    label: "≤ 0 mm",
  },
  {
    codigo: 1,
    minMm: 0,
    maxMm: 10,
    color: "#81D4FA",
    label: "0 - 10 mm",
  },
  {
    codigo: 2,
    minMm: 10,
    maxMm: 20,
    color: "#29B6F6",
    label: "10 - 20 mm",
  },
  {
    codigo: 3,
    minMm: 20,
    maxMm: 40,
    color: "#0288D1",
    label: "20 - 40 mm",
  },
  {
    codigo: 4,
    minMm: 40,
    maxMm: 60,
    color: "#66BB6A",
    label: "40 - 60 mm",
  },
  {
    codigo: 5,
    minMm: 60,
    maxMm: 80,
    color: "#43A047",
    label: "60 - 80 mm",
  },
  {
    codigo: 6,
    minMm: 80,
    maxMm: 100,
    color: "#FDD835",
    label: "80 - 100 mm",
  },
  {
    codigo: 7,
    minMm: 100,
    maxMm: 120,
    color: "#FB8C00",
    label: "100 - 120 mm",
  },
  {
    codigo: 8,
    minMm: 120,
    maxMm: 140,
    color: "#E53935",
    label: "120 - 140 mm",
  },
  {
    codigo: 9,
    minMm: 140,
    maxMm: 160,
    color: "#8E24AA",
    label: "140 - 160 mm",
  },
  {
    codigo: 10,
    minMm: 160,
    maxMm: Number.POSITIVE_INFINITY,
    color: "#4A148C",
    label: "> 160 mm",
  },
];

export const RAINFALL_UNIT = "mm";
